import { cn } from '@/lib/utils'

interface DesktopPageHeaderProps {
  title: string
  subtitle?: string
  /** Small breadcrumb line under the title row, e.g. `Operations / Trips`. */
  breadcrumb?: React.ReactNode
  /** Right-aligned action slot, e.g. an "Add Trip" button. */
  action?: React.ReactNode
  className?: string
}

/**
 * Shared header for desktop screens — large title + subtitle, an optional
 * breadcrumb, and a right-aligned action slot. Mirrors the Figma operations
 * layout (title block left, primary action top-right).
 */
export function DesktopPageHeader({
  title,
  subtitle,
  breadcrumb,
  action,
  className,
}: DesktopPageHeaderProps) {
  return (
    <header className={cn('flex flex-col gap-4', className)}>
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <h1 className="text-[48px] font-semibold leading-none tracking-[-0.48px] text-content-primary-bold">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-2 text-base text-content-primary-subtle">{subtitle}</p>
          )}
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </div>
      {breadcrumb && (
        <div className="text-sm font-medium text-content-brand-bold">
          {breadcrumb}
        </div>
      )}
    </header>
  )
}
